module.exports = require("./es-EC");